import React, { useState, useEffect } from 'react';
import { get } from 'lodash/fp';
import styled from 'styled-components';
import { requestService, getHeaders } from 'services/api/utils';
import { COLORS } from 'styles/theme/colors';

function VersionInfo() {
  const [data, setData] = useState('');

  useEffect(async () => {
    const res = await requestService('/api/app-version', {
      method: 'get',
      headers: getHeaders(),
    });

    setData(res);
  }, []);

  return (
    <VersionInfo.Body>
      <VersionInfo.Section>
        <VersionInfo.Header>Version</VersionInfo.Header>
        <VersionInfo.Data>{get('version')(data) || 'N/A'}</VersionInfo.Data>
      </VersionInfo.Section>
      <VersionInfo.Section>
        <VersionInfo.Header>SHA</VersionInfo.Header>
        <VersionInfo.SHA
          href={`https://github.com/goatapp/partner-portal/commit/${get('sha')(data) || ''}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {get('sha')(data) || 'N/A'}
        </VersionInfo.SHA>
      </VersionInfo.Section>
    </VersionInfo.Body>
  );
}

VersionInfo.Body = styled.div`
  background-color: rgb(16, 16, 16);
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

VersionInfo.Section = styled.div`
  border: 1px solid ${COLORS.primaryVersionInfoBorder};
  height: 200px;
  width: 200px;
  color: ${COLORS.primaryText};
  padding: 10px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

VersionInfo.Header = styled.h1`
  color: ${COLORS.primaryText};
`;

VersionInfo.Data = styled.h2`
  color: ${COLORS.primaryText};
`;

VersionInfo.SHA = styled.a`
  word-break: break-word;
  font-size: 10px;
  color: ${COLORS.primaryText};
  width: 100%;

  &:visited {
    color: ${COLORS.primaryText};
  }
`;

export default VersionInfo;
